var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"map-btn R-color",style:(_vm.coordinates),attrs:{"id":_vm.button.id},on:{"click":function($event){return _vm.collabdata($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }